import { NotifyHelper } from "../../../helpers/toast";
import { eKhoiNganhActionsObj } from "../../action-types/category/IKhoiNganhActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const khoiNganhActions = {
    ...generateActions(eKhoiNganhActionsObj, "KHOI_NGANH"),
    ...generateActionForKey(eKhoiNganhActionsObj, "KHOI_NGANH", "LOAD_ERROR", (m) => {
        NotifyHelper.Error(m);
    }),
};
